import { render, staticRenderFns } from "./AlipayCallback.vue?vue&type=template&id=6f715153&scoped=true"
import script from "./AlipayCallback.vue?vue&type=script&lang=js"
export * from "./AlipayCallback.vue?vue&type=script&lang=js"
import style0 from "./AlipayCallback.vue?vue&type=style&index=0&id=6f715153&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f715153",
  null
  
)

export default component.exports